import { Component, OnInit } from '@angular/core';
import { AdminService } from './admin.service';
import { Router, ActivatedRoute} from '@angular/router';
import { CommonDataService, KeyValuePair } from '../common-data/commondata.service';
import * as _ from 'lodash';


@Component({
    providers: [AdminService],
    //templateUrl: 'app/administration/user.component.html'
    template: require('./user.component.html'),
})
 
export class UserComponent implements OnInit {
    
    alerts: any[]; 
    public origUser: any;
    private sub: any;
    private idParam: number;
    //this may actually need to be public
    private newUser: boolean; 
    pageTitle: string;
    user: any;
    roles: any;
    regions: KeyValuePair[]; 
    
    constructor(private router: Router,
        private adminService: AdminService, 
        private _commonDataService: CommonDataService,
        private route: ActivatedRoute) {}    
 
    ngOnInit() : void{

        this.sub = this.route.params.subscribe(
            params => {
            let id = params['id'];

            if(id === undefined){
                this.newUser = true;
                this.pageTitle = 'Create User';
			    this.user = {};
                this.getRoles();            
            }
            else{
                this.newUser = false;
                this.pageTitle = 'Edit User';

                this.idParam = id;

                //console.log(this.idParam);

                this.adminService.getUsers().subscribe(
                    data => {
                        let users = data;
                        this.user = _.find(users, function(user: any){				
	    			        return user.id === Number(id);
		    	        });
                        this.origUser = _.cloneDeep(this.user);
                        this.getRoles();            
                    });
            }
        });

        
        this.getKeyValues('region');
    }

    private getKeyValues(id: string)
    {
        this._commonDataService.getData(id)
            .subscribe(
                (list: KeyValuePair[]) => {
                    if(id == "region"){
                        this.regions = list;
                    }
                }
            );
    }

    getRoles(){
        this.adminService.getRoles()
            .subscribe(
                roles => {
                    this.roles = roles;
                        this.selectRole();   
            });
    }

    selectRole(){
	    if(this.user && this.user.roles){
            let roleId = this.user.roles[0].id;
            this.user.selectedRole = _.find(this.roles, function(role: any){
			    return role.id === roleId;
            });	
		}else{	    
			this.user.selectedRole = this.roles[1];
		}			
	}


    submitUser(){

        this.alerts = [];

		if(this.newUser){
            this.adminService.usernameExists(this.user.userName)
                .subscribe(
                    success => {
                        if(success == true){
                            this.alerts.push({type: 'danger', msg: 'User Name is Already in Use'});
                        }
                        else{
                            this.adminService.emailExists(this.user.email)
                                .subscribe(
                                    success => {
                                        if(success == true){
                                            this.alerts.push({type: 'danger', msg: 'Email is Already in Use'});
                                        }
                                        else{
                                            this.saveUser();
                                        }
                                    },
                                    error => {
                                        this.alerts.push({type: 'danger', msg: 'Error Occured Connecting to Server'});
                                    })
                        }
                    },
                    error => {
					    this.alerts.push({type: 'danger', msg: 'Error Occured Connecting to Server'});
                    });
        }
        else{
            this.saveUser();
        }

    }



	saveUser(){
        this.alerts = [];

		this.user.role = this.user.selectedRole.name;
        
		if(this.newUser){
			//TODO: not sure I need this
            this.user.baseUrl = window.location.href.substring(0, window.location.href.lastIndexOf('/'));

            this.adminService.createUser(this.user)
                .subscribe(
                    success => this.router.navigate(['/admin']),
                    error => {
					    this.alerts.push({type: 'danger', msg: 'Creation failed.'});
                    });
		}else{
            this.adminService.updateUser(this.user)
                .subscribe(
                    success => this.router.navigate(['/admin']),
                    error => {
					    this.alerts.push({type: 'danger', msg: 'Update failed.'});
                    });
		}
	}

	resetForm(){			
		this.user = this.origUser;
		this.selectRole();
        //https://github.com/angular/angular/pull/9974
		//this.form.markAsPristine();
	}

	closeAlert(index: any) {
        this.alerts.splice(index, 1);
    }
}




   


/** WEBPACK FOOTER **
 ** ./app/administration/user.component.ts
 **/